export enum CandidateRegistrationTab {
  REGISTRATION = 'registration',
}

export enum CandidateRegistrationStep {
  CREATE_PASSWORD = '0',
  OTP = '1',
}
